export default __webpack_public_path__ + "static/media/partyIcon.fafd3435.png";